import { Form, Input } from "antd";

const { TextArea } = Input;

export function AppInput({
  label,
  name,
  placeholder,
  value,
  onChange,
  rules = [],
  type = "text",
  ...rest
}) {
  const handleChange = (e) => {
    const newValue = e.target ? e.target.value : e;
    if (onChange) {
      onChange({ target: { name, value: newValue } });
    }
  };

  const handlePhoneValidation = (event) => {
    const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight"];
    const { key } = event;

    // Allow only digits and allowed keys
    if (!allowedKeys.includes(key) && !/\d/.test(key)) {
      event.preventDefault();
    }

    const { value } = event.target;

    // Prevent typing more than 11 characters
    if (value.length >= 11 && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  };

  const handleNumberValidation = (event) => {
    const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete"];
    const { key } = event;

    // Allow only digits and allowed keys
    if (!allowedKeys.includes(key) && !/\d/.test(key)) {
      event.preventDefault();
    }
  };

  return (
    <Form.Item
      label={label}
      name={name}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      rules={[
        ...rules,
        ...(type === "email"
          ? [
              {
                type: "email",
                message: "Please enter a valid email address!",
              },
            ]
          : []),
      ]}
    >
      {type === "textarea" ? (
        <TextArea
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          {...rest}
        />
      ) : type === "number" ? (
        <Input
          type="text" // Use text to remove spinner
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          onKeyDown={handleNumberValidation} // Apply number validation
          {...rest}
        />
      ) : type === "phone" ? (
        <Input
          type={type === "phone" ? "text" : "number"} // Use text for phone
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          onKeyDown={type === "phone" ? handlePhoneValidation : undefined} // Apply phone validation
          {...rest}
        />
      ) : (
        <Input
          type={type}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          {...rest}
        />
      )}
    </Form.Item>
  );
}

export default AppInput;
